import {
  AreaChart as MantineAreaChart,
  getFilteredChartTooltipPayload,
} from '@mantine/charts'
import { Box } from '@mantine/core'

import type { AreaChartProps } from '@/components/AreaChart/AreaChart.types'

import { formatMoney } from '@/helpers/formatMoney.helper'

import classes from './AreaChart.module.css'

function ChartTooltip({
  payload,
}: {
  payload: Record<string, any>[] | undefined
}) {
  if (!payload) return null

  return (
    <Box>
      {getFilteredChartTooltipPayload(payload).map(item => (
        <Box key={item.payload.date} className={classes.chartTooltip}>
          {formatMoney(item.value, 'USD', { signed: true })}
        </Box>
      ))}
    </Box>
  )
}

export function AreaChart({ data, dataKey, series, ...props }: AreaChartProps) {
  return (
    <MantineAreaChart
      data={data}
      dataKey={dataKey}
      h={248}
      {...props}
      activeDotProps={{
        fill: 'var(--mantine-other-colors-white)',
        r: 8,
        strokeWidth: 4,
      }}
      className={classes.root}
      curveType="bump"
      dotProps={{ r: 0 }}
      fillOpacity={0}
      series={series}
      strokeWidth={4}
      tooltipAnimationDuration={200}
      tooltipProps={{
        content: ({ payload }) => <ChartTooltip payload={payload} />,
      }}
      type="stacked"
      valueFormatter={value => formatMoney(value, 'USD', { signed: true })}
    />
  )
}
